import { render, staticRenderFns } from "./ShowIntegration.vue?vue&type=template&id=051d0db8&"
import script from "./ShowIntegration.vue?vue&type=script&lang=js&"
export * from "./ShowIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051d0db8')) {
      api.createRecord('051d0db8', component.options)
    } else {
      api.reload('051d0db8', component.options)
    }
    module.hot.accept("./ShowIntegration.vue?vue&type=template&id=051d0db8&", function () {
      api.rerender('051d0db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/ShowIntegration.vue"
export default component.exports